import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';

import Spinner, { SpinnerOverlayContent } from 'Components/Spinner/Spinner';
import history from 'customHistory';
import { RegApi } from 'BackEnd/API';
import { log } from 'common/utils/logging.util';
import routes from 'common/constants/routing.constants';

const RawVerifyEmailPage = ({
  AuthStore: { isAuthorised },
  ProfileStore: { metaData },
}) => {
  useEffect(() => {
    const query = new URLSearchParams(window?.location.search);
    const code = query.get('code');
    const verifyID = query.get('confirm');
    const err = query.get('err');
    if (verifyID && code) {
      RegApi.confirmEmail({ code, verifyID })
        .then(() => {
          if (metaData.StartedFromWizard) {
            history.push(routes.wizard.path);
          } else {
            history.push(
              isAuthorised
                ? routes.profile.path
                : routes.auth.confirmEmail.postConfirm.path,
            );
          }
        })
        .catch((err) => {
          console.log(err, 'err');
          const errorText = err?.response?.data || 'true';
          log(
            `verifying email failed for verifyID ${verifyID} code ${code}`,
            'error',
          );
          history.push(`/verify-email?err=${errorText}`);
        });
    } else {
      history.push(`/verify-email?err=${err}`);
    }
  }, []);

  return (
    <SpinnerOverlayContent>
      <Spinner />
    </SpinnerOverlayContent>
  );
};

export const VerifyEmailPage = inject(
  'AuthStore',
  'ProfileStore',
)(observer(RawVerifyEmailPage));
